export default "__VITE_ASSET__DYAG5mNq__"